import React from "react";
import DMMediaSlider from "./DMMediaSlider";
import DMVideoItem from "./DMVideoItem";
import AudioElement from "./AudioElement";
const DMMedia = ({
  mediaLength,
  file,
  mediaType,
  mediaLinks,
  setSlideIndex,
  fullLinks,
  setImages,
}) => {
  if (mediaType === "wav") {
    return <AudioElement src={mediaLinks[0]} />;
  }
  if (mediaLength > 1) {
    return (
      <DMMediaSlider
        file={file}
        mediaLinks={mediaLinks}
        setSlideIndex={setSlideIndex}
        setImages={setImages}
        fullLinks={fullLinks}
      />
    );
  }
  if (mediaType === "mp4") {
    return <DMVideoItem src={mediaLinks[0]} />;
  }
  return (
    <div
      className="selfie"
      onClick={() => {
        setImages(fullLinks);
        setSlideIndex(0);
      }}
    >
      <img src={mediaLinks[0]} alt="Solo Image" />
    </div>
  );
};

export default DMMedia;
